// Who may change what on the Game Attendance screen (SN-8476).
//
// A team official on the team edits everything. Anyone else on the team opens
// it read-only — except for their OWN players (themselves, their kids: the
// home widget's `myPlayers` on that team), whose availability they may still
// set, exactly as they can from the home widget. Nothing else is editable for
// them. Shared by web + mobile.

type OwnPlayerSource = { id: string; team_id?: string | null }

export interface AttendanceAccess {
  isReadOnly: boolean
  // Players on this team whose availability the viewer may set in read-only.
  ownPlayerIds: readonly string[]
}

/** The ids of the viewer's own players on `teamId`. */
export const getOwnPlayerIds = (
  myPlayers: readonly OwnPlayerSource[] | null | undefined,
  teamId: string | null | undefined
): string[] =>
  teamId
    ? (myPlayers ?? [])
        .filter((player) => player.team_id === teamId)
        .map((player) => player.id)
    : []

/** Whether the viewer may set this player's availability. */
export const canEditAvailability = (
  playerId: string,
  { isReadOnly, ownPlayerIds }: AttendanceAccess
): boolean => !isReadOnly || ownPlayerIds.includes(playerId)
